import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../context/AuthContext";
import { generateGPSummaryData } from "../../services/generateGPSummaryClient";

export function useGPSummary() {
  const { user } = useAuth();

  return useQuery({
    queryKey: ["gp-summary", user?.uid],
    queryFn: () => generateGPSummaryData(user!.uid),
    enabled: !!user,
    staleTime: 10 * 60 * 1000,
  });
}
